import * as React from "react"
import {useRoutes} from "react-router-dom";

import {useRoutesApp} from "./@hooks";
import AppTheme from "./Theme";
import AnalyticsRouter from "@analytics/router";

import 'rsuite/dist/rsuite-no-reset.min.css';
import 'react-multi-carousel/lib/styles.css';


export default function App() {
    const { routesApp } = useRoutesApp()
    const elements = useRoutes(routesApp)

    // <AnalyticsRouter/> renders nothing; it needs useLocation, so it must sit inside the
    // BrowserRouter that renderApp provides — this component already does.
    return <AppTheme>
        <AnalyticsRouter/>
        {elements}
    </AppTheme>
}